import React, { memo, useState } from 'react'
import Active from '../../commons/Active'
import Inactive from '../../commons/Inactive'
import { makeStyles, Icon, Modal, Backdrop, Fade } from '@material-ui/core'
import TableCell from '../../commons/TableCell'
import ResultsTable from '../../ResultsTable'
import CloseIcon from '@material-ui/icons/Close'
import DeviceHubNew from 'images/icons/subdomain/DeviceHubNew'
import { OPERACIONES_SUBDOMINIOS } from 'utils/constants'
import { useHasOperation } from 'hooks/useHasOperation'

const useStyles = makeStyles(theme => ({
   iconRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   iconText: {
      marginLeft: theme.spacing(1)
   },
   buttonImage: {
      cursor: 'pointer',
      color: '#8A8FAB',
      borderBottom: '1px solid blue'
   },

   containerModal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },

   containerPaper: {
      backgroundColor: 'white',
      boxShadow: theme.shadows[5],
      boxShadow: '0 3px 4px -1px #d1d5db',
      borderRadius: '0.275rem',
      position: 'relative'
   },
   containerIcon: {
      position: 'absolute',
      top: '10px',
      right: '10px',
      cursor: 'pointer'
   },

   containerImg: {
      padding: '100px'
   }
}))

function SubdomainTable({
   isSearch,
   order,
   searchSubdomains,
   subdomains,
   actionEdit,
   cleanCallback,
   iconsMap,
   customActions
}) {
   const classes = useStyles()
   const VER_CODIGO_SUBDOMINIO = useHasOperation(OPERACIONES_SUBDOMINIOS.VER_CODIGO_SUBDOMINIO)


   const columns = [
      {
         title: 'NOMBRE SUBDOMINIO',
         field: 'name',
         align: 'center',
         sorting: !!isSearch,
         customSort: () => 0,
         defaultSort: order,
         render: rowData => <TableCell text={rowData?.name} />
      },
      {
         title: 'DESCRIPCIÓN SUBDOMINIO',
         field: 'description',
         align: 'center',
         sorting: false,
         render: rowData => <TableCell text={rowData?.description} />
      },
      {
         title: 'ESTADO SUBDOMINIO',
         field: 'status',
         align: 'center',
         sorting: false,
         render: rowData => (rowData?.status === 'A' ? <Active /> : <Inactive />)
      },
      {
         title: 'ICONO SUBDOMINIO',
         field: 'icon',
         sorting: false,
         align: 'center',
         render: rowData => (
            <>
               {rowData?.icon && (
                  <div className={classes.iconRow}>
                     {rowData.icon === 'device_hub_new' ? (
                        <DeviceHubNew color="#8a8fab" />
                     ) : (
                        <Icon>{iconsMap && iconsMap[rowData.icon] && iconsMap[rowData.icon].name}</Icon>
                     )}

                     <span className={classes.iconText}>{rowData.icon}</span>
                  </div>
               )}
            </>
         )
      },
      {
         title: 'Mapa Mundo Mutual',
         field: 'mapa',
         sorting: false,
         align: 'center',
         render: rowData => <TableCell text={rowData?.mapa ? rowData.mapa : 'No disponible'} />
      },
      {
         title: 'ICONO MUNDO MUTUAL',
         field: 'description',
         align: 'center',
         sorting: false,
         render: rowData => <ActiveLink rowData={rowData} />
      },
      {
         title: 'FECHA REGISTRO',
         field: 'createdDate',
         sorting: false,
         align: 'center'
      },
      {
         title: 'USUARIO REGISTRO',
         field: 'createdBy',
         sorting: false,
         align: 'center'
      }
   ]

   return (
      <ResultsTable
         name="subdomains"
         columns={columns}
         tableData={subdomains}
         isSearch={isSearch}
         searchCallback={searchSubdomains}
         customActions={customActions}
         cleanCallback={cleanCallback}
         actionEdit={actionEdit}
         order={order}
         enableKey={VER_CODIGO_SUBDOMINIO}
      />
   )
}

const ActiveLink = ({ rowData }) => {
      const classes = useStyles()

      const [statusModal, setStatusModal] = useState(false)

      return (
         <>
            {rowData.mutualWorld ? (
               <span className={classes.buttonImage} onClick={() => setStatusModal(true)}>
                  Ver imagen
               </span>
            ) : (
               <a></a>
            )}
            {statusModal && (
               <Modal
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  className={classes.containerModal}
                  open={statusModal}
                  onClose={() => setStatusModal(false)}
                  closeAfterTransition
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                     timeout: 500
                  }}
               >
                  <Fade in={statusModal}>
                     <div className={classes.containerPaper}>
                        <div className={classes.containerImg}>
                           <div onClick={() => setStatusModal(false)} className={classes.containerIcon}>
                              <CloseIcon />
                           </div>
                           <img src={rowData.mutualWorld.image} alt="" />
                        </div>
                     </div>
                  </Fade>
               </Modal>
            )}
         </>
      )
   }

export default memo(SubdomainTable)
